module.exports = "/images/risk-slideshow-2-v2.png?6c0665ed11489b086b5f052d34a4dc3f";